import { TimeFormatType } from './time-format-key'

const timeFormatValues = new Set<string>(Object.values(TimeFormatType))

function isTimeFormatType(value: string | null): value is TimeFormatType {
  return value !== null && timeFormatValues.has(value)
}

export function normalizeTimeFormat(value: string | null): TimeFormatType | null {
  return isTimeFormatType(value) ? value : null
}
